/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useMemo } from 'react';
import { Link } from 'react-router-dom';
import slugify from 'react-slugify';
import { meetingSimpleSelectors } from '../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { IMeetingSimple } from '../../../../../app/resource/meeting-simple/meeting-simple.types';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { Notifications } from '../NavigationBar/Notifications';
import { Settings } from '../NavigationBar/Settings';
import { Support } from '../NavigationBar/Support';
import { IMeetingDashboardNavbarProps } from './types';
import { CircularAvatar } from '../../CustomAvatar';
import { useTenantBranding } from '../../../../../utils/custom-hooks/useTenantBranding.utils';

export const MeetingDashboardNavbar: FunctionComponent<IMeetingDashboardNavbarProps> = ({ meetingId, showLoader }) => {
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId) as IMeetingSimple;
  const { iconLogo, tenantName } = useTenantBranding();

  let memberIds = [] as string[];
  if (meeting) {
    memberIds = Array.from(new Set([...meeting?.administratorIds, ...meeting?.shareWithIds]));
  }

  const teamColor = useMemo(() => meeting?.color, [meeting]);

  return (
    meeting && (
      <div className="row mb-2">
        <div className="col-12">
          <div className="panel single-line flex aic jcc p-0">
            {showLoader ? (
              <span className="css-loader--meeting-dashboard-navbar"></span>
            ) : (
              <>
                <Link
                  to={`/meeting-dashboard/${meeting.id}/${slugify(meeting.title, {
                    delimiter: '-',
                  })}`}
                >
                  <CircularAvatar
                    src={meeting.image}
                    title={meeting.title}
                    color={teamColor}
                    size="60"
                    classes="bold"
                    textSizeRatio={2.5}
                    styles={{ margin: '10px 20px' }}
                  />
                </Link>
              </>
            )}

            <h2 className="bold" style={{ marginLeft: '5px' }}>
              {meeting.title}
            </h2>
            <ul className="right-menu" style={{ height: 80 }}>
              {/* <li className="flex aic">
                <a href="" className="btn btn-md darkGray-bg ml-1">
                  Reports
                </a>
              </li>
              <li className="flex aic">
                <a href="" className="btn btn-md darkGray-bg ml-1">
                  Company Vision
                </a>
              </li> */}

              {/* <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={openAgendaItemsDialog}
                  className="panel-button no-border popup_button"
                >
                  <i className="icon-dots" />
                </a>
              </li> */}
              <li className="panel-text ml-2">
                <CircularAvatar src={iconLogo} title={tenantName} size="30" />
              </li>
              <li className="panel-text ml-2 pr-2">{tenantName}</li>
              <li className="panel-text ml-2 pr-2">
                <Link
                  to={`/reports/meetings/${meetingId}/${slugify(meeting.title, { delimiter: '-' })}`}
                  className="btn btn-md"
                >
                  Meeting Reports
                </Link>
              </li>
              <Support />
              <Notifications meetingId={meetingId} />
              <Settings />
            </ul>
          </div>
        </div>
      </div>
    )
  );
};
